/** Carácter que confirma uma opção ao digitar (não usar vírgula — pode fazer parte do texto). */
export const OPTION_ENTRY_CHAR = ";";

/** Separa opções ao colar ou no parse final (ponto e vírgula ou quebra de linha). */
export const OPTION_ENTRY_SPLIT_REGEX = /[;\n\r]+/;

export function normaliseOptionLabel(s) {
  return String(s || "").trim().replace(/\s+/g, " ");
}

export function parseOptionEntryText(text) {
  const raw = String(text || "");
  if (!raw.trim()) return [];
  return raw
    .split(OPTION_ENTRY_SPLIT_REGEX)
    .map(normaliseOptionLabel)
    .filter(Boolean);
}

export function textHasBulkOptionSeparators(text) {
  return OPTION_ENTRY_SPLIT_REGEX.test(String(text || ""));
}
